// src/ContextManager.tsx
import { ReactNode, useEffect } from 'react';
import InitialChecks from './InitialChecks/InitialChecks';
import { UserContext, useUser } from '../services/User';
import { useOrdersNotifications } from '../hooks/useNotifications/useOrdersNotifications';
import { ShipmentsContext, useDeliveries } from '../services/Deliveries';
import { OrdersContext, useOrders } from '../services/Orders';
import { BotmakerChatContext, useBotmakerChat } from '../services/BotmakerChat';

interface Props {
    children: ReactNode;
}

function ContextManager({ children }: Props) {
    const user = useUser();
    const deliveries = useDeliveries();
    const orders = useOrders(user.loading ? undefined : user.user);
    const chatContext = useBotmakerChat(orders);
    useOrdersNotifications(Object.values(orders.ordersById), user.user.id);

    return (
        <UserContext.Provider value={user}>
            <ShipmentsContext.Provider value={deliveries}>
                <OrdersContext.Provider value={orders}>
                    <BotmakerChatContext.Provider value={chatContext}>
                        <InitialChecks />
                        {children}
                    </BotmakerChatContext.Provider>
                </OrdersContext.Provider>
            </ShipmentsContext.Provider>
        </UserContext.Provider>
    );
}

export default ContextManager;
